const routes = [
    {
        path: '/admin/overview',
        name: 'admin-overview',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/overview'),
        meta: {}
    },
    {
        path: '/admin/verify',
        name: 'admin-verify',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/verify'),
        meta: {},

    },
    {
        path: '/admin/users',
        name: 'admin-users',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/users'),
        meta: {},

    },
    {
        path: '/admin/videos',
        name: 'admin-videos',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/videos'),
        meta: {
            filter:'admin'
        },

    },
    {
        path: '/admin/images',
        name: 'admin-images',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/images'),
        meta: {
            filter:'admin'
        },

    },
    {
        path: '/admin/profile-images',
        name: 'admin-profileImages',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/profile_images'),
        meta: {
            filter:'admin'
        },

    },

    {
        path: '/admin/faceblock',
        name: 'admin-faceblock',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/faceblock'),
        meta: {
            filter:'admin'
        },

    },

    {
        path: '/admin/auto-topup',
        name: 'admin-auto-topup',
        component: () => import(/* webpackChunkName: "/dyn/admin" */ '#/admin/auto-topup'),
        meta: {
            filter:'admin'
        },

    },


]
export default routes
